var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-list", [_c("a-list-item")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }